@if (view=='slider') {
  <app-clips-slider
    [clips]="filteredClips"
    [position]="imagePosition"
    (closeView)="view='home'">
  </app-clips-slider>
}

<div class="box subtittle">
  {{'Clips' | translate}} ({{clips.length}})
  <div class="checkBoxContainer">
    <input (click)="validateShowSelected()" type="checkbox" name="show_selected" [(ngModel)]="showSelected">
    <p>{{'Show only selected by director' | translate}}</p>
  </div>
</div>

<div class="box">
  @if (!loading) {
    <div class="clip-container">
      @for (clip of filteredClips; track clip; let i = $index) {
        <div (click)="viewSlider(i)" class="clip columns L-3 M-4 S-6 XL-2">
          @if (clip.selected_clip) {
            <a class="show-selected"></a>
          }
          <div class="clip-image">
          <!-- video *ngIf="clip.clip_url" width="100%" height="100%" src="{{clip.clip_url}}"></video-->
          <!-- <video *ngIf="clip.clip_url" width="100%" height="100%" src="/../assets/img/{{clip.clip_url}}"></video> -->
          @if (!clip.clip_url) {
            <img src="/../assets/img/no_video.png" alt="">
          }
          @if (clip.clip_url) {
            <img [src]="clip.clip_thumbnails" alt="">
          }
        </div>
        <p title="{{clip.clip_name}}">{{clip.clip_name}}</p>
        @if (clip.date) {
          <span>{{'Unit' | translate}} {{clip.unit_number}}, {{clip.date | date: 'MMM/dd/yyyy'}}</span>
        }
      </div>
    }
    @if (!filteredClips.length) {
      <p>{{'No clips added to this scene' | translate}}</p>
    }
  </div>
}
@if (loading) {
  <div class="container-loader">
    <div class="loader loader-img"></div>
    <p>{{'Connecting to CI' | translate}}...</p>
  </div>
}
</div>
